module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Warlord’s Bride")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewPage",
    attrs: {
      "id": "pra01"
    }
  }, [_c('h2', {
    staticClass: "reviewPageHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Praise for "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("USA TODAY")])]), _vm._v(" bestselling author"), _c('br'), _vm._v("\nMargaret Moore")])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Fans of historicals will be unable to put Ms. Moore’s story down. The story is fresh, fun, fast-paced, engaging, and passionate, with an added touch of adventure.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Romance Readers Connection on The Notorious Knight")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Filled with fast-paced dialogue and historical details that add depth and authenticity to the story. Readers will be well entertained.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Romantic Times BOOKreviews")])]), _vm._v(" on "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("My Lord’s Desire")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Readers continue to ask for ‘Moore.’ Her latest book is a sparkling, dynamic tale of two lonely hearts who find each other despite their pasts and the evil forces surrounding them.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Romantic Times BOOKreviews")])]), _vm._v(" on "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hers To Desire")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Colorful and compelling details of life in the Middle Ages abound.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Publishers Weekly")])]), _vm._v(" on "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hers To Command")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“A lively adventure with enough tension and romance to keep me turning pages.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—National bestselling author Roberta Gellis on "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hers To Command")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“This captivating adventure of 13th-century Scotland kept me enthralled from beginning to end. It’s a keeper!”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Romance Junkies")])]), _vm._v(" on "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Bride of Lochbarr")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Margaret Moore is a master storyteller who has the uncanny ability to develop new twists on old themes.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Affaire de Coeur")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e3ce84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/warlordsbridethe_pra01.vue
// module id = 60
// module chunks = 0